import { Add } from '@mui/icons-material';
import { Box, ButtonBase, IconButton, Tooltip } from '@mui/material';
import { FC, useState } from 'react';
import { useIntl } from 'react-intl';
import { useModalContext } from '../../modal/ModalContext';
import { useTypedPathParams } from '../../../../shared/fe/hooks/useTypedPathParams';

import { journeyDetailSchema } from '../detail/JourneyDetailPage';
import { getNightOrDayPalette } from '../../utils/getNightOrDayPalette';

const TABLE_FOOTER_HEIGHT = 80;
const TIMELINE_DIVIDER_OFFSET = 1;

type Props = Readonly<{ tableHeight: number; phaseId: string; isTimeline: boolean; buttonOffset?: number }>;
export const AddPhaseDividerButton: FC<Props> = ({ tableHeight, phaseId, isTimeline = false, buttonOffset = 0 }) => {
	const intl = useIntl();
	const [showAddPhase, setShowAddPhase] = useState<boolean>(false);
	const { setModal } = useModalContext();
	const { id } = useTypedPathParams(journeyDetailSchema);

	const buttonHeight = isTimeline ? tableHeight - TIMELINE_DIVIDER_OFFSET : tableHeight - TABLE_FOOTER_HEIGHT;

	return (
		<ButtonBase
			sx={{
				position: 'absolute',
				top: 0,
				left: -15,
				width: 30,
				height: buttonHeight,
				zIndex: 1,
			}}
			onMouseEnter={() => setShowAddPhase(true)}
			onMouseLeave={() => setShowAddPhase(false)}
			onClick={() => setModal({ type: 'createPhase', payload: { id: id, phaseId: phaseId } })}
		>
			<Tooltip title={intl.formatMessage({ id: 'detail.add-phase.divider' })} arrow placement={'top'}>
				<IconButton
					sx={{
						borderRadius: '100%',
						backgroundColor: (theme) => theme.palette.primary[400],
						width: 20,
						height: 20,
						top: isTimeline ? buttonOffset / 2 : 0,
						left: -1,
						zIndex: 1,
						opacity: showAddPhase ? 1 : 0,
						'&:hover': {
							backgroundColor: (theme) => theme.palette.primary[400],
						},
					}}
				>
					<Add sx={{ width: 16, height: 16, color: (theme) => theme.palette.grey[0] }} />
				</IconButton>
			</Tooltip>
			<Box
				sx={{
					position: 'absolute',
					top: 0,
					left: 13.5,
					width: 2,
					height: buttonHeight,
					border: 0,
					background: (theme) =>
						showAddPhase
							? theme.palette.primary[400]
							: `linear-gradient(to bottom, transparent 50%, ${theme.palette[getNightOrDayPalette(theme)][300]} 50%)`,
					backgroundSize: showAddPhase ? undefined : '100% 12px',
				}}
			/>
		</ButtonBase>
	);
};
